<template>
  <div
    class="drop-zone"
    :class="{ hovering: isHovering }"
    @drop="dropHandler"
    @dragover="dragOverHandler"
    @dragenter="(event) => dragAreaHandler(event, true)"
    @dragleave="(event) => dragAreaHandler(event, false)">
    <div
      style="
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-size: 20px;
        row-gap: 12px;
      ">
      {{ msg }}
      <span><v-icon style="font-size: 50px">mdi-arrow-down-bold</v-icon></span>
    </div>
  </div>
</template>
<script setup>
import { state } from '../../../stores/deluge';
import { ref, watch } from 'vue';
import { $http } from '../../../stores/http';
const cueURL = (did) => `/dynamic_engine/cue/${did}`;

const isHovering = ref(false);
const firstMsg = 'Drop Scene here to Cue it';
const secondMsg = "That's it, now drop it!";

const msg = ref(firstMsg);

function hoverOn(on) {
  if (on) {
    msg.value = secondMsg;
    isHovering.value = true;
  } else {
    msg.value = firstMsg;
    isHovering.value = false;
  }
}

function dragAreaHandler(event, entering) {
  if (state.cueTakeUI.sceneDragActive && entering) {
    // browser only understands we can do this with a preventDefault here, else default is to not allow a drop.
    event.preventDefault();
    hoverOn(true);
  } else {
    hoverOn(false);
  }
}

function dragOverHandler(event) {
  if (state.cueTakeUI.sceneDragActive) {
    // browser only understands we can do this with a preventDefault here, else default is to not allow a drop.
    event.preventDefault();
    if (isHovering.value == false) {
      hoverOn(true);
    }
  }
}

async function dropHandler() {
  const sceneDID = state.cueTakeUI.sceneDraggedDID;
  if (sceneDID) {
    state.cueTakeUI.sceneDropped = true;
    hoverOn(true);
    await $http('POST', cueURL(sceneDID));
  }
}
</script>

<style scoped>
.drop-zone {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  /* background-color: var(--v-primary-base); */
  /* background-color: var(--primary-color-trans);
  color: var(--primary-color); */
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  background-color: var(--primary-color-trans);
  color: var(--primary-color-light-text);
  background-image:
    repeating-linear-gradient(
      0deg,
      var(--primary-color),
      var(--primary-color) 10px,
      transparent 10px,
      transparent 20px,
      var(--primary-color) 20px
    ),
    repeating-linear-gradient(
      90deg,
      var(--primary-color),
      var(--primary-color) 10px,
      transparent 10px,
      transparent 20px,
      var(--primary-color) 20px
    ),
    repeating-linear-gradient(
      180deg,
      var(--primary-color),
      var(--primary-color) 10px,
      transparent 10px,
      transparent 20px,
      var(--primary-color) 20px
    ),
    repeating-linear-gradient(
      270deg,
      var(--primary-color),
      var(--primary-color) 10px,
      transparent 10px,
      transparent 20px,
      var(--primary-color) 20px
    );
  background-size:
    3px calc(100% + 20px),
    calc(100% + 20px) 3px,
    3px calc(100% + 20px),
    calc(100% + 20px) 3px;
  background-position:
    0 0,
    0 0,
    100% 0,
    0 100%;
  background-repeat: no-repeat;
}

.hovering {
  animation: borderAnimation 0.8s infinite linear;
}

@keyframes borderAnimation {
  from {
    background-position:
      0 0,
      -20px 0,
      100% -20px,
      0 100%;
  }
  to {
    background-position:
      0 -20px,
      0 0,
      100% 0,
      -20px 100%;
  }
}
</style>
